import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { forwardRef } from 'react';
import { useIntl } from 'react-intl';

import { i18n as tableI18n } from '../DataTable.i18n';
import { useStyles } from '../DataTable.styles';

export interface DataTableFilterBarProps {
    showSearch?: boolean;
    searchValue?: string;
    onSearchChange?: (value: string) => void;
    searchPlaceholder?: string;
}

export const DataTableFilterBar = forwardRef<HTMLDivElement, DataTableFilterBarProps>(
    function DataTableFilterBar(
        { showSearch = false, searchValue = '', onSearchChange, searchPlaceholder },
        ref,
    ) {
        const intl = useIntl();
        const { classes } = useStyles();
        const resolvedSearchPlaceholder =
            searchPlaceholder ?? intl.formatMessage(tableI18n.searchPlaceholder);

        if (!showSearch) return null;

        return (
            <Box ref={ref} className={classes.filterBar} automation-id="filter-bar">
                {showSearch && (
                    <TextField
                        value={searchValue}
                        onChange={(e) => onSearchChange?.(e.target.value)}
                        placeholder={resolvedSearchPlaceholder}
                        size="small"
                        className={classes.searchInput}
                        automation-id="filter-search"
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                ),
                            },
                        }}
                    />
                )}
            </Box>
        );
    },
);
